import { render, staticRenderFns } from "./adjuntar_archivos.vue?vue&type=template&id=aa29f5e6&lang=pug&"
import script from "./adjuntar_archivos.vue?vue&type=script&lang=js&"
export * from "./adjuntar_archivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports